import React from "react";
const engageAIContent = {
  overview: {
    title: "inFlow EngageAI",
    headline: "AI agents that elevate every business interaction",
    description:
      "inFlow EngageAI deploys conversational AI agents across voice, chat, and digital channels to automate customer support, sales inquiries, and appointment bookings — delivering 24/7 intelligent engagement.",
    imageURL: "/images/products/EngageAI-3D-Studio-Banner.png",
    screenURL: "/images/products/EngageAI-3D-Studio-Banner.png",
    buttons: [
      "Customer Support",
      "Credit card payment",
      "iNextLabs Voice Assistant",
    ],
  },
  demos: [
    {
      title: "Customer Support",
      tag: "text",
      path: "/demo/customer-support",
      image: "/images/products/EngageAI-CustomerSupport.png",
      description: [
        "Experience an AI assistant that handles L1 queries, raises tickets, shares status updates, and logs feature requests — all in one seamless flow.",
      ],
    },
    {
      title: "Credit Card Reminders",
      tag: "voice",
      path: "/demo/credit-card-reminder",
      image: "/images/products/EngageAI-CreditCardReminder.png",
      description: [
        "Explore how a voice agent makes outbound calls to remind users of upcoming dues, share payment summaries, and answers follow-up questions.",
      ],
    },
    {
      title: "Sales Assistant",
      tag: "voice",
      path: "/demo/sales-assistance",
      image: "/images/products/SalesAssistant.png",
      description: [
        "Experience a voice assistant that guides prospects through product offerings, answers solution-specific queries, and captures demo requests.",
      ],
    },
    {
      title: "Appointment Booking",
      tag: "voice",
      path: "/demo/appointment-booking",
      image: "/images/products/EngageAI-Appointment-Booking.png",
      description: [
        "Explore how a voice agent automates appointment bookings by confirming doctor availability, capturing patient details, and scheduling visits in seconds. ",
      ],
    },
    {
      title: "Avatar Bot",
      tag: "Avatar",
      path: "/demo/avatar-bot",
      image: "/images/products/EngageAI-AvatarBot.png",
      description: [
        "A general-purpose AI assistant that answers open-ended questions. Interact using text or voice and get instant responses in a human-like avatar format.",
      ],
    },
    {
      title: "Clinical Assistant",
      tag: "text",
      path: "/demo/clinical-assistant",
      image: "/images/products/clinical-assistant.png",
      description: [
        "Enables patients to explore services, ask questions, and manage appointments — including booking, rescheduling, and cancellations .",
      ],
    },
    {
      title: "Virtual Mall Concierge",
      tag: "Avatar",
      path: "/demo/virtual-mall-concierge",
      image: "/images/products/EngageAI-AvatarBot.png",
      description: [
        "AI-powered mall assistant providing instant support, product recommendations, and smooth shopping guidance.",
      ],
    },
    {
      title: "PSD Avatar",
      tag: "Avatar",
      path: "/demo/psd-avatar",
      image: "/images/products/EngageAI-AvatarBot.png",
      description: [
        "AI-powered avatar that simulates real customer conversations, helping support teams practice, improve responses, and build confidence through realistic interactions.",
      ],
    },
  ],
  pricing: {
    plans: [
      {
        id: "advantage",
        name: "ADVANTAGE",
        price: 399,
        period: "month",
        conversations: "2,000 conversations / month",
        popular: false,
        features: [
          { label: "Users", value: "10" },
          { label: "Live Agents", value: "4" },
          { label: "Broadcast Messages/month", value: "100,000" },
          { label: "Storage", value: "75 GB" },
          { label: "Agent Languages", value: "3" },
          { label: "Text", value: true },
          { label: "Image", value: true },
          { label: "Handwriting", value: true },
          { label: "Voice", value: true },
          { label: "Avatar", value: false },
          { label: "Web", value: true },
          { label: "WhatsApp", value: true },
          { label: "Social Media", value: true },
          { label: "Email Channel", value: true },
          { label: "Telephone Channel", value: false },
          { label: "User Feedback", value: true },
          { label: "Content from verified websites", value: true },
          { label: "Custom Prompt", value: true },
          { label: "Ask AI", value: true },
          { label: "Continuous Learning", value: true },
          { label: "Omni Channel Support", value: false },
          { label: "PII Masking", value: false },
          { label: "InFlow Copilot", value: false },
          { label: "InFlow Shield", value: false },
          { label: "Support", value: "Bot + Email + Phone" }
        ]
      },
      {
        id: "premium",
        name: "PREMIUM",
        price: 599,
        period: "month",
        conversations: "3,000 conversations / month",
        popular: true,
        features: [
          { label: "Users", value: "15" },
          { label: "Live Agents", value: "6" },
          { label: "Broadcast Messages/month", value: "200,000" },
          { label: "Storage", value: "100 GB" },
          { label: "Agent Languages", value: "5" },
          { label: "Text", value: true },
          { label: "Image", value: true },
          { label: "Handwriting", value: true },
          { label: "Voice", value: true },
          { label: "Avatar", value: false },
          { label: "Web", value: true },
          { label: "WhatsApp", value: true },
          { label: "Social Media", value: true },
          { label: "Email Channel", value: true },
          { label: "Telephone Channel", value: false },
          { label: "User Feedback", value: true },
          { label: "Content from verified websites", value: true },
          { label: "Custom Prompt", value: true },
          { label: "Ask AI", value: true },
          { label: "Continuous Learning", value: true },
          { label: "Omni Channel Support", value: true },
          { label: "PII Masking", value: true },
          { label: "InFlow Copilot", value: false },
          { label: "InFlow Shield", value: false },
          { label: "Support", value: "Bot + Email + Phone" }
        ]
      },
      {
        id: "ultimate",
        name: "ULTIMATE",
        price: 899,
        period: "month",
        conversations: "5,000 conversations / month",
        popular: false,
        features: [
          { label: "Users", value: "25" },
          { label: "Live Agents", value: "10" },
          { label: "Broadcast Messages/month", value: "unlimited" },
          { label: "Storage", value: "150 GB" },
          { label: "Agent Languages", value: "10" },
          { label: "Text", value: true },
          { label: "Image", value: true },
          { label: "Handwriting", value: true },
          { label: "Voice", value: true },
          { label: "Avatar", value: true },
          { label: "Web", value: true },
          { label: "WhatsApp", value: true },
          { label: "Social Media", value: true },
          { label: "Email Channel", value: true },
          { label: "Telephone Channel", value: true },
          { label: "User Feedback", value: true },
          { label: "Content from verified websites", value: true },
          { label: "Custom Prompt", value: true },
          { label: "Ask AI", value: true },
          { label: "Continuous Learning", value: true },
          { label: "Omni Channel Support", value: true },
          { label: "PII Masking", value: true },
          { label: "InFlow Copilot", value: true },
          { label: "InFlow Shield", value: true },
          { label: "Support", value: "Bot + Email + Phone" }
        ]
      }
    ],
  },
  usecase: [
    {
      industry: "Healthcare ",
      points: [
        "Handling appointment booking, rescheduling, and reminders through web and WhatsApp",
        "Assisting with patient inquiries related to doctors, departments, services, and insurance coverage ",
        "Collecting patient feedback post-visit to improve care quality and operational efficiency",
        "Running awareness campaigns and health promotion initiatives via automated outreach",
      ],
    },
    {
      industry: "Real Estate & Property Management ",
      points: [
        "Automate responses to rental/buying inquiries across listings ",
        "Schedule site visits or virtual tours via WhatsApp ",
        "Manage maintenance requests and tenant communication ",
        "Answer FAQs on lease terms, facilities, and documentation",
      ],
    },
    {
      industry: "Banking & Financial Services ",
      points: [
        "Automating responses to FAQs around account openings, loans, credit cards, and investments",
        "Collecting KYC documents and scheduling branch appointments via secure conversational flows",
        "Enabling product recommendation journeys based on user intent and eligibility",
        "Managing grievance redressal with AI triage and smart escalation to relationship managers ",
      ],
    },
    {
      industry: "Retail & eCommerce ",
      points: [
        "Assisting users with product discovery, availability, and pricing queries ",
        "Guiding customers through order placement, returns, cancellations, and refund status",
        "Providing multilingual chatbot support during high-traffic events and seasonal sales ",
        "Promoting offers and new arrivals with personalized engagement campaigns",
      ],
    },
    {
      industry: "Travel, Transport & Hospitality",
      points: [
        "Handling inquiries related to bookings, cancellations, ticket changes, and travel advisories",
        "Assisting customers with loyalty programs, special offers, and local recommendations ",
        "Collecting guest feedback and satisfaction surveys after stay or travel experiences ",
        "Automating internal requests like housekeeping, room service, or airport pickup coordination",
      ],
    },
    {
      industry: "Workplace Automation (HR, IT, Admin) ",
      points: [
        "Answering employee queries on leave policy, benefits, payroll, or onboarding ",
        "Logging and triaging IT tickets related to hardware, software, or access requests",
        "Assisting with booking, scheduling, and admin requests ",
        "Supporting hybrid workforce needs through voice and chat-based virtual assistants ",
      ],
    },
  ],
  customerstory: {
    stories: [
      {
        text: "Transformation of a Renowned Tea Brand with Our WhatsApp Bot Solution",
        url: "https://inextlabs.ai/resources/tealive-casestudy",
      },
      {
        text: "Discover how iNextLabs' WhatsApp chatbot bolstered an FMCG brand?",
        url: "https://inextlabs.ai/resources/vdonaturals-whatsapp-casestudy",
      },
      {
        text: "AI-Powered WhatsApp Order Management",
        url: "/images/automated-order-intake.pdf"
      }
    ],
  },
  resources: {
    diagrams: [
      {
        name: "EngageAI for Customer Service",
        type: "video",
        tag: "VIDEO",
        image: "EngageAI-for-Customer Service.mp4",
        duration: "12 min",
        size: "Video · 31.8 MB",
        desc: "Watch how EngageAI helps teams resolve queries faster and deliver exceptional support.",
        isHero: true,
      },
      {
        name: "EngageAI for Smart Ordering",
        type: "video",
        tag: "VIDEO",
        image: "EngageAI-for-smart-ordering.mp4",
        duration: "8 min",
        size: "Video · 15.8 MB",
        desc: "See how AI agents automate ordering and streamline the entire intake process.",
      },
      {
        name: "EngageAI for Sales Intelligence",
        type: "video",
        tag: "VIDEO",
        image: "EngageAI-Sales-Intelligence.mp4",
        duration: "10 min",
        size: "Video · 48.9 MB",
        desc: "Discover real-time lead qualification and conversational sales intelligence.",
      },
      {
        name: "Voice Bot Architecture",
        type: "diagram",
        tag: "DIAGRAM",
        image: "architecture/STS Arch Diagram.png",
        size: "PNG · 277 KB",
        desc: "High-resolution architectural diagram of multi-modal voice processing topology.",
      },
      {
        name: "EngageAI for Customer Service Brochure",
        type: "pdf",
        tag: "PDF",
        image: "brochure/customerService.pdf",
        size: "PDF · 3.6 MB",
        desc: "Detailed overview of customer service AI capabilities, features, and outcomes.",
      },
      {
        name: "EngageAI for Sales Intelligence Brochure",
        type: "pdf",
        tag: "PDF",
        image: "brochure/SalesIntelligence.pdf",
        size: "PDF · 2.4 MB",
        desc: "Discover key sales capabilities, ROI metrics, and real business impact.",
      },
      {
        name: "EngageAI proposal",
        type: "doc",
        tag: "DOC",
        image: "documents/inFlowEngageAI-proposal.docx",
        size: "DOCX · 6.2 MB",
        desc: "Explore complete system architecture, commercial terms, and rollout roadmap.",
      },
      {
        name: "Customer Support Proposal",
        type: "doc",
        tag: "DOC",
        image: "documents/inFlowEngageAI-proposal.docx",
        size: "DOCX · 1.4 MB",
        desc: "Tailored enterprise SLA support specifications and multi-channel coverage.",
      },
    ],
  },
};

export default engageAIContent;
